import { renderSlot as _renderSlot, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-358d1303")

_pushScopeId("data-v-358d1303")
const _hoisted_1 = { class: "validate-edit-box" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("label", {
      class: ["edit-box-label", [_ctx.$mq, _ctx.required ? 'required' : '']],
      for: _ctx.id
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 10, ["for"]),
    _createVNode("input", _mergeProps({ id: _ctx.id }, _ctx.$props, {
      type: _ctx.inputType,
      class: _ctx.inputClass,
      disabled: _ctx.readonly,
      value: _ctx.modelValue,
      ref: "focusRef",
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
    }), null, 16, ["id", "type", "disabled", "value"])
  ]))
})